/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'news-feed-dividend-reinvestment': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M29 27h-5v-5M18.5 11c0-1-1.567-2-3.5-2s-3.5 1.343-3.5 3 1.75 2.5 3.5 3 3.5 1.343 3.5 3-1.567 3-3.5 3-3.5-1-3.5-2M15 21.5v1M15 7.5V9"/><path pid="1" d="M25.607 25.607A14.953 14.953 0 0030 15c0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 4.142 1.679 7.892 4.393 10.607"/></g>'
  }
})
